module.exports = __webpack_public_path__ + "img/能源类.9e07784c.png";